var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"list-inline"},_vm._l((_vm.components),function(component){return _c('li',{staticClass:"list-inline-item mr-4"},[_c('div',{staticClass:"mx-auto text-center"},[_c('i',{class:component.icon_class}),_vm._v(" "),(_vm.showBr)?_c('br'):_vm._e(),_vm._v("\n            "+_vm._s(component.name)+"\n        ")])])}),0)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-441d6810","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/Assets/components/RegistrationCategories/Tickets/Utility/RaceComponents.vue
// module id = 2169
// module chunks = 1